import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ListProductsComponent } from './list-products/list-products.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { SearchComponent } from './search/search.component';
import { PageNotFoundComponent } from '../core/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    component: ListProductsComponent,
    title: 'Outils',
    data: { revalidate: 900 },
  },
  { path: 'search', component: SearchComponent, title: 'Recherche' },
  {
    path: ':id',
    component: ProductDetailsComponent,
    data: { revalidate: 900 },
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductRoutingModule {}
